module.exports = __webpack_public_path__ + "static/media/align.ec00f38c.svg";